import React from "react"

import BreadcrumbNav from "components/Common/BreadcrumbNav"
import FullSpinner from "components/Common/FullSpinner"

import useResumen from "./useResumen"
import { BREADCRUMB_LIST, TAB_GENERAL, TAB_PEDIDOS } from "./static"
import ResumenTabs from "./components/ResumenTabs"
import GeneralTab from "./components/GeneralTab"
import OrdersTab from "./components/OrdersTab"

import "./resumen.css"

/**
 * Pantalla «Resumen» del distribuidor.
 *
 * No usa `PageBase` como el resto de pantallas rediseñadas: quien la enruta
 * —pages/Dashboard/index.js— ya aporta `page-content`, `MetaTags` y el
 * `Container fluid` para los tres portales, y envolverla otra vez duplicaría
 * el contenedor.
 */
const ResumenContainer = () => {
  const { state, events } = useResumen()

  return (
    <>
      {state.isLoading && <FullSpinner />}

      <BreadcrumbNav title="Resumen" items={BREADCRUMB_LIST} />

      <div className="res-page mt-3">
        <ResumenTabs activa={state.tab} onChange={events.onChangeTab} />

        {state.tab === TAB_GENERAL && (
          <GeneralTab state={state} events={events} />
        )}

        {state.tab === TAB_PEDIDOS && (
          <OrdersTab
            datos={state.pedidos.datos}
            isLoading={state.pedidos.isLoading}
          />
        )}
      </div>
    </>
  )
}

export default ResumenContainer
